<!-- This footer component is only for Desktop view, tabs.component.ts is the footer for hybrid view (tablet, mobile) also contains the
redirection behavior -->
<div
  *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
  id="footer"
>
  <ion-footer>
    <ion-toolbar>
      <ion-grid [fixed]="true">
        <ng-container
          *ngIf="
            (orderService.restrictNavigationForCurrentOrder$ | async) !== true;
            else navigationRestrictedTemplate
          "
        >
          <ion-row>
            <!-- USF Logo -->
            <ion-col
              *ngIf="!manageCustomizationsLogo"
              class="usf-logo-col"
              size-xl="2"
            >
              <ion-img
                *ngIf="
                  (this.panAppState?.currentUrl$ | async) !==
                  '/desktop/order/order-exceptions'
                "
                data-cy="footer-usf-logo-color-image"
                src="assets/images/usfoods-logo-color.svg"
              ></ion-img>
              <!-- Does this still exist? -->
              <ion-img
                *ngIf="
                  (this.panAppState?.currentUrl$ | async) ===
                  '/desktop/order/order-exceptions'
                "
                data-cy="footer-usf-logo-gray-image"
                src="assets/images/usfoods-logo-gray.svg"
              ></ion-img>
            </ion-col>
            <ion-col
              *ngIf="manageCustomizationsLogo"
              class="usf-logo-col"
              size-xl="2"
            >
              <app-logo
                [footer]="true"
                [isManageCustomizationsLogo]="manageCustomizationsLogo"
              ></app-logo>
            </ion-col>

            <!-- Customer Service -->
            <ion-col
              offset-xl="0.25"
              size-xl="2.50"
              size-lg="2.50"
              size-md="2.75"
              size-sm="2.75"
              size-xs="2.75"
            >
              <h5 data-cy="footer-customer-service-label">
                {{ 'i18n.footer.customerService' | translate }}
              </h5>
              <ul data-cy="footer-customer-service-links-section">
                <li *ngIf="(isGuestUser$ | async) === false">
                  <a
                    data-cy="footer-help-center-link"
                    href="https://www.usfoods.com/our-services/moxe-help-center.html"
                    target="_blank"
                  >
                    {{ 'i18n.footer.helpCenter' | translate }}
                  </a>
                </li>
                <li>
                  <a
                    data-cy="footer-food-safety-recalls-link"
                    href="https://www.usfoods.com/food-safety.html"
                    target="_blank"
                  >
                    {{ 'i18n.footer.foodSafety' | translate }}
                  </a>
                </li>
                <li>
                  <a
                    data-cy="footer-usf-locations-link"
                    href="https://www.usfoods.com/locations.html"
                    target="_blank"
                  >
                    {{ 'i18n.footer.locations' | translate }}
                  </a>
                </li>
                <li>
                  <a
                    *ngIf="
                      (serviceRequestFeatureFlag$ | async) &&
                      (isGuestUser$ | async) === false
                    "
                    data-cy="footer-request-credit-link"
                    (click)="navigationHandler('/desktop/' + requestCreditPath)"
                  >
                    {{ 'i18n.requestCredit.requestCredit' | translate }}
                  </a>
                </li>
              </ul>
            </ion-col>

            <!-- About Us -->
            <ion-col
              offset-xl="0.25"
              offset-lg="1"
              offset-md="0.65"
              offset-sm="0.65"
              offset-xs="0.65"
              size-xl="1.5"
              size-lg="2"
              size-md="2.25"
              size-sm="2.25"
              size-xs="2.25"
            >
              <h5 data-cy="footer-about-us-label">
                {{ 'i18n.footer.aboutUs' | translate }}
              </h5>
              <ul data-cy="footer-about-us-links-section">
                <li>
                  <a
                    data-cy="footer-careers-link"
                    [href]="careersUrl"
                    target="_blank"
                  >
                    {{ 'i18n.footer.careers' | translate }}
                  </a>
                </li>

                <li>
                  <a
                    data-cy="footer-leadership-link"
                    href="https://ir.usfoods.com/investors/corporate-governance/management/default.aspx"
                    target="_blank"
                  >
                    {{ 'i18n.footer.leadership' | translate }}
                  </a>
                </li>
                <li>
                  <a
                    data-cy="footer-news-link"
                    href="https://ir.usfoods.com/investors/stock-information-news/default.aspx"
                    target="_blank"
                  >
                    {{ 'i18n.footer.news' | translate }}
                  </a>
                </li>
                <li>
                  <a
                    data-cy="footer-food-fanatics-link"
                    [href]="foodFanaticsUrl"
                    target="_blank"
                  >
                    {{ 'i18n.footer.foodFanatics' | translate }}
                  </a>
                </li>
              </ul>
            </ion-col>

            <!-- More From US Foods -->
            <ion-col
              offset-xl="0.75"
              offset-lg="0.75"
              offset-md="0.50"
              offset-sm="0.50"
              offset-xs="0.50"
              size-xl="2.5"
              size-lg="3"
              size-md="3.25"
              size-sm="3.25"
              size-xs="3.25"
            >
              <h5 data-cy="footer-more-from-usf-label">
                {{ 'i18n.footer.moreFrom' | translate }}
              </h5>
              <ul>
                <li>
                  <a
                    data-cy="footer-ces-link"
                    href="https://www.usfoods.com/great-food/culinary-equipment-supplies.html"
                    target="_blank"
                  >
                    {{ 'i18n.footer.culinaryEquip' | translate }}
                  </a>
                </li>
                <li>
                  <a
                    data-cy="footer-stockyards-link"
                    href="https://www.usfoods.com/why-us-foods/our-programs/stock-yards.html"
                    target="_blank"
                  >
                    {{ 'i18n.footer.stockyards' | translate }}
                  </a>
                </li>
                <li>
                  <a
                    data-cy="footer-our-brands-link"
                    [href]="ourBrandsUrl"
                    target="_blank"
                  >
                    {{ 'i18n.footer.ourBrands' | translate }}
                  </a>
                </li>
              </ul>
            </ion-col>

            <!-- Social Media -->
            <ion-col
              offset-xl="0.75"
              offset-lg="0.75"
              offset-md="0.50"
              offset-sm="0.50"
              offset-xs="0.50"
              size-xl="1.50"
              size-lg="2"
              size-md="2.10"
              size-sm="2.10"
              size-xs="2.10"
            >
              <div data-cy="footer-social-info-section" class="social-info">
                <article class="social-media-icons">
                  <a
                    data-cy="footer-facebook-link"
                    href="https://www.facebook.com/usfoods"
                    target="_blank"
                  >
                    <ion-icon
                      data-cy="footer-facebook-icon"
                      name="logo-facebook"
                    ></ion-icon>
                  </a>
                  <a
                    data-cy="footer-twitter-link"
                    href="https://twitter.com/usfoods"
                    target="_blank"
                  >
                    <img
                      data-cy="footer-twitter-icon"
                      src="assets/icon/twitter-x-logo.svg"
                      height="25"
                      width="auto"
                    />
                  </a>
                  <a
                    data-cy="footer-youtube-link"
                    href="https://www.youtube.com/user/usfoods"
                    target="_blank"
                  >
                    <ion-icon
                      data-cy="footer-youtube-icon"
                      name="logo-youtube"
                    ></ion-icon>
                  </a>
                </article>

                <article class="phone-information">
                  <ng-container *ngIf="divisionInfo$ | async; let divisionInfo">
                    <ng-container
                      *ngIf="
                        divisionInfo?.telephoneNumber !== null &&
                        divisionInfo?.telephoneNumber !== ''
                      "
                    >
                      <ng-container *ngIf="(isGuestUser$ | async) === false">
                        <p data-cy="footer-ordering-info-label">
                          {{ 'i18n.footer.orderingInfo' | translate }}
                        </p>
                        <aside
                          *ngIf="(divisionPhoneNumber$ | async)?.length === 0"
                          data-cy="footer-ordering-info-phone-text"
                        >
                          <a
                            data-cy="footer-phone-link"
                            [href]="'tel:+1' + divisionInfo?.telephoneNumber"
                          >
                            {{
                              divisionInfo?.telephoneNumber | phoneNumberFormat
                            }}
                          </a>
                        </aside>
                        <aside
                          *ngIf="(divisionPhoneNumber$ | async)?.length > 0"
                          data-cy="footer-ordering-info-phone-text"
                        >
                          <a
                            data-cy="footer-phone-link"
                            [href]="'tel:+1' + (divisionPhoneNumber$ | async)"
                          >
                            +1
                            {{
                              divisionPhoneNumber$ | async | phoneNumberFormat
                            }}
                          </a>
                        </aside>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <p data-cy="footer-technical-info-label">
                    {{ 'i18n.footer.technicalInfo' | translate }}
                  </p>
                  <aside data-cy="footer-technical-info-phone-text">
                    <a data-cy="footer-phone-help-link" href="tel:+18775839659">
                      +1 (877) 583-9659
                    </a>
                  </aside>
                </article>
              </div>
            </ion-col>
          </ion-row>

          <!--  Policy Links -->
          <ng-container
            *ngIf="
              (this.panAppState?.currentUrl$ | async) !==
              '/desktop/order/order-exceptions'
            "
          >
            <ion-row>
              <ion-col offset-xl="2.25" size-xl="9.75">
                <div data-cy="footer-policy-links-section" class="policy-links">
                  <a
                    data-cy="footer-terms-of-access-link"
                    href="https://www.usfoods.com/policies/index.html"
                    target="_blank"
                    >{{ 'i18n.footer.terms' | translate }}</a
                  >
                  <span data-cy="footer-policy-link-separator-text"> | </span>
                  <a
                    data-cy="footer-privacy-policy-link"
                    href="https://www.usfoods.com/policies/privacy.html"
                    target="_blank"
                    >{{ 'i18n.footer.privacyPolicy' | translate }}</a
                  >
                  <span data-cy="footer-policy-link-separator-text"> | </span>
                  <a
                    data-cy="footer-customer-policy-link"
                    href="https://www.usfoods.com/policies/customer.html"
                    target="_blank"
                    >{{ 'i18n.footer.customerPolicy' | translate }}</a
                  >
                  <span data-cy="footer-policy-link-separator-text"> | </span>
                  <a
                    data-cy="footer-about-site-link"
                    href="https://www.usfoods.com/policies/about.html"
                    target="_blank"
                    >{{ 'i18n.footer.aboutSite' | translate }}</a
                  >
                  <span data-cy="footer-policy-link-separator-text"> | </span>
                  <a
                    data-cy="footer-contact-us-link"
                    href="https://www.usfoods.com/policies/contact.html"
                    target="_blank"
                    >{{ 'i18n.footer.contactUs' | translate }}</a
                  >
                  <p
                    data-cy="footer-usfoods-copyright-text"
                    class="copyright-text"
                  >
                    &copy; {{ currentYear }} US Foods.
                    {{ 'i18n.footer.allRightsReserved' | translate }}.
                  </p>
                </div>
              </ion-col>
            </ion-row>
          </ng-container>
        </ng-container>
        <ng-template #navigationRestrictedTemplate>
          <ion-row>
            <ion-col class="ion-align-items-end" size="3">
              <ng-container
                *ngIf="
                  !manageCustomizationsLogo ||
                  (orderService.restrictNavigationForCurrentOrder$ | async) ===
                    true
                "
              >
                <ion-img
                  class="logo"
                  src="assets/images/usfoods-logo-gray.svg"
                ></ion-img>
              </ng-container>

              <ng-container
                *ngIf="
                  manageCustomizationsLogo &&
                  (orderService.restrictNavigationForCurrentOrder$ | async) !==
                    true
                "
              >
                <app-logo [footer]="true"></app-logo>
              </ng-container>
            </ion-col>
          </ion-row>
        </ng-template>
      </ion-grid>
    </ion-toolbar>
  </ion-footer>
</div>
